<template>
  <footer
    class="footer footer-black"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <div class="">
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-66 t_footleft md-small-size-100">
            <h4>Soical Feed</h4>
            <md-list>
              <md-list-item>
                <md-button target="_self" href="https://www.facebook.com/daysinnsherman" class="md-just-icon md-darkblue t_foot-icon">
                  <i class="fab fa-facebook-square"></i>
                </md-button>
                <p>All our coupons posted in there!</p>
              </md-list-item>
              <md-list-item>
                <md-button target="_self" href="https://www.twitter.com/DaysSherman" class="md-just-icon md-blue t_foot-icon">
                  <i class="fab fa-twitter-square"></i>
                </md-button>
                <p>Our true words of welcome you!</p>
              </md-list-item>
              <md-list-item>
                <md-button target="_self" href="https://www.instagram.com/daysinnsherman" class="md-just-icon md-white t_foot-icon">
                  <i class="fab fa-instagram"></i>
                </md-button>
                <p>Our Pictures!</p>
              </md-list-item>
            </md-list>
            <h4>Contact Us</h4>
            <md-list>
              <md-list-item>
                <i class="material-icons">map</i>
                <p class="t_lp">3605 US-75, <br>
                  Sherman, TX 75090</p>
              </md-list-item>

              <md-list-item>
                <i class="material-icons">contact_phone</i>
                <p class="t_lp">(903) 868-0555</p>
              </md-list-item>

              <md-list-item>
                <i class="material-icons">message</i>
                <p class="t_lp">(903) 718-0189</p>
              </md-list-item>
            </md-list>
          </div>
          <!-- <div class="md-layout-item md-size-33">
            
          </div> -->
          <div class="md-layout-item md-size-33 md-small-size-100">
            <h4>Menu</h4>
            <md-list>
              <md-list-item target="_self" href="/meetingRooms">
                <i class="material-icons">meeting_room</i>
                <p>Meeting Rooms</p>
              </md-list-item>
              
              <md-list-item target="_self" href="/guestRooms">
                <i class="material-icons">local_hotel</i>
                <p>Guest Rooms</p>
              </md-list-item>

              <md-list-item target="_self" href="/kitchen">
                <i class="material-icons">restaurant</i>
                <p>Restaurant</p>
              </md-list-item>

              <md-list-item target="_self" href="/packages">
                <i class="material-icons">shop_two</i>
                <p>Packages</p>
              </md-list-item>

              <md-list-item target="_self" href="/activities">
                <i class="material-icons">local_activity</i>
                <p>Activities</p>
              </md-list-item>

              <md-list-item target="_self" href="/contactus">
                <i class="material-icons">contacts</i>
                <p>Contact</p>
              </md-list-item>

              <!-- <md-list-item target="_self" href="/aboutus">
                <i class="material-icons">people</i>
                <p>About Us</p>
              </md-list-item> -->
            </md-list>
          </div>
        </div>
      </div>
      <hr>
      <div class="content">
        <nav>
          <a target="_self" href="/"><img :src="logoUrl" alt="orange tree"></a>
          <!-- <ul>
            <li>
              <a target="_self" href="/contact">
                Contact
              </a>
            </li>
            <li>
              <a target="_self" href="/aboutUs">
                About Us
              </a>
            </li>
          </ul> -->
        </nav>
        <div class="copyright">
          &copy; {{ year }}, OrangeTree Bar & Restaurant
          <!-- <md-icon>favorite</md-icon> by
          <a target="_self" href="https://www.creative-tim.com/">Creative Tim</a>
          for a better web. -->
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
// import BasicElements from "@/views/components/BasicElementsSection";
export default {
  // components: {
  //   BasicElements
  // },
  props: {
    backgroundColor: String,
    type: String,
    logoUrl: {
      type: String,
      default: require("@/assets/img/smallLogo1.png")
    }
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style lang="scss" scoped>
.footer-black {
    background-color: #232323;
    background: radial-gradient(ellipse at center,#585858 0,#232323 100%);
    background-size: 550% 450%;
    color: #fff!important;
  .container {
    display: block;
  }
  .content {
    width: 100%;
    height: auto;
    text-align: left;
    display: flex;
    box-pack: justify;
    justify-content: space-between;
    position: relative;
  }
  ul {
    li:first-child a {
      margin-left: 0;
    }
  }
  .md-list.md-theme-default{
    background: transparent;
    
  }
  .md-list-item {

    p {
      padding-left: 10px;
      font-size: 1rem !important;
      color: rgba(255, 255, 255, 0.7)!important;
      margin-bottom: 0!important;
      white-space: normal!important;
    }
    i {
      font-size: 2rem;
      color: rgba(255, 255, 255, 0.7);
    }
  }
  .t_footleft {
    .md-list-item {
      margin: -4px 0 !important;
    }
    p {
      flex: 1;
      font-weight: normal !important; 
    }
  }
  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    width: 100%;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }
  img{
    margin: 15px 0;
  }
  i{
    font-size: 1.5rem!important;
  }
  .t_foot-icon{
    height: 30px;
    min-width: 30px;
    width: 30px;
    line-height: 30px;
  }
}
</style>
